import React from "react";
import { Layout, Dropdown, Avatar } from "antd";
import { UserOutlined, LogoutOutlined, ProfileOutlined, CalendarOutlined, BarChartOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import LogoImg from "../../Components/Assests/Images/logo.png";

const { Header, Content } = Layout;

export default function DoctorLayout({ children }) {
    const navigate = useNavigate();
    const location = useLocation();

    const profileMenuItems = [
        {
            key: "profile",
            label: (
                <span className="d-flex align-items-center gap-2">
                    <ProfileOutlined />
                    Profile
                </span>
            ),
        },
        {
            key: "logout",
            label: (
                <span className="d-flex align-items-center gap-2 text-danger">
                    <LogoutOutlined />
                    Logout
                </span>
            ),
        },
    ];

    const handleMenuClick = ({ key }) => {
        if (key === "profile") {
            navigate("/doctor/profile");
        }

        if (key === "logout") {
            sessionStorage.clear();
            localStorage.clear();
        
            navigate("/");
        }
    };

    return (
        <Layout className="min-vh-100 bg-white">
            <Layout>
                <Header className="bg-white px-4 px-lg-8 border-bottom h-auto sticky-top" style={{ zIndex: 1000 }}>
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <div className="d-flex align-items-center gap-4 flex-wrap">
                            <div className="fw-bolder text-success fs-1 mb-0">
                                <img
                                    src={LogoImg}
                                    alt="Logo"
                                    style={{
                                        height: "42px",
                                        width: "auto",
                                        maxWidth: "140px",
                                        objectFit: "contain",
                                        display: "block",
                                    }}
                                />
                            </div>

                            <div
                                className="mb-0 fw-bold fs-1"
                                style={{
                                    color: "#102a5c",
                                    fontFamily: '"Playfair Display", "Poppins", serif',
                                    letterSpacing: "0.5px",
                                }}
                            >
                                Kayathri Dental Care
                            </div>
                        </div>
<Dropdown
    menu={{
        items: profileMenuItems,
        onClick: handleMenuClick,
    }}
    trigger={["hover", "click"]}
    placement="bottomRight"
>
    <div
        className="d-flex align-items-center gap-2"
        style={{ cursor: "pointer" }}
    >
        {/* 👤 Avatar */}
        <div
            className="d-flex align-items-center justify-content-center rounded-circle bg-light-primary text-primary shadow-sm"
            style={{
                width: "42px",
                height: "42px",
            }}
        >
            <Avatar size={36} icon={<UserOutlined />} />
        </div>

        {/* 👨‍⚕️ Role Text */}
        <div className="fw-semibold text-dark">
            Doctor
        </div>
    </div>
</Dropdown>
                    </div>
                </Header>

                <div className="px-4 px-lg-8 py-2">
                    <div className="d-flex justify-content-end">
                        <div className="d-flex gap-4 align-items-center">
                            <div
                                className={`d-flex align-items-center gap-2 fw-semibold pb-2 
                                    ${location.pathname === "/doctor/dashboard"
                                        ? "border-bottom border-2 border-primary text-primary"
                                        : "text-muted"
                                    }`}
                                style={{ cursor: "pointer", transition: "0.2s" }}
                                onClick={() => navigate("/doctor/dashboard")}
                            >
                                <CalendarOutlined />
                                Appointments
                            </div>
                            <div
                                className={`d-flex align-items-center gap-2 fw-semibold pb-2 
                                    ${location.pathname === "/doctor/reports"
                                        ? "border-bottom border-2 border-primary text-primary"
                                        : "text-muted"
                                    }`}
                                style={{ cursor: "pointer", transition: "0.2s" }}
                                onClick={() => navigate("/doctor/reports")}
                            >
                                <BarChartOutlined />
                                Reports
                            </div>

                        </div>
                    </div>
                </div>

                <Content className="p-4 p-lg-8 bg-body-tertiary">
                    {children}
                </Content>
            </Layout>
        </Layout>
    );
}
